/* Kitchuan homepage: finish comparison slider (kc-compare) and set cards with a colour switch (kc-set-card). */
if (!customElements.get('kc-compare')) {
  class KcCompare extends HTMLElement {
    connectedCallback() {
      if (this.kcReady) return;
      this.kcReady = true;
      this.frame = this.querySelector('[data-kc-frame]');
      this.range = this.querySelector('[data-kc-range]');
      if (!this.frame || !this.range) return;
      this.start = null;
      this.dragging = false;
      this.range.addEventListener('input', () => this.set(Number(this.range.value)));
      this.frame.addEventListener('pointerdown', (e) => this.down(e));
      this.frame.addEventListener('pointermove', (e) => this.move(e));
      this.frame.addEventListener('pointerup', (e) => this.up(e));
      this.frame.addEventListener('pointercancel', () => this.reset());
      this.frame.addEventListener('lostpointercapture', () => { this.dragging = false; });
      this.set(Number(this.range.value) || 50);
    }

    at(e) {
      const r = this.frame.getBoundingClientRect();
      return ((e.clientX - r.left) / r.width) * 100;
    }

    set(value) {
      const p = Math.max(0, Math.min(100, value));
      this.frame.style.setProperty('--kc-pos', p + '%');
      this.frame.style.setProperty('--kc-p', String(p));
      const rounded = String(Math.round(p));
      if (this.range.value !== rounded) this.range.value = rounded;
    }

    grab(e) {
      this.dragging = true;
      try { this.frame.setPointerCapture(e.pointerId); } catch (err) { /* pointer already released */ }
      this.set(this.at(e));
    }

    down(e) {
      if (e.pointerType === 'mouse') {
        if (e.button !== 0) return;
        e.preventDefault();
        this.grab(e);
        return;
      }
      // Touch and pen: wait to see whether this is a sideways drag or a page scroll.
      this.start = { x: e.clientX, y: e.clientY, id: e.pointerId };
    }

    move(e) {
      if (this.dragging) {
        this.set(this.at(e));
        return;
      }
      if (!this.start || e.pointerId !== this.start.id) return;
      const dx = Math.abs(e.clientX - this.start.x);
      const dy = Math.abs(e.clientY - this.start.y);
      if (dx > 6 && dx > dy) this.grab(e);
    }

    up(e) {
      if (!this.dragging && this.start && e.pointerId === this.start.id) this.set(this.at(e));
      this.reset();
    }

    reset() {
      this.dragging = false;
      this.start = null;
    }
  }
  customElements.define('kc-compare', KcCompare);
}

if (!customElements.get('kc-set-card')) {
  class KcSetCard extends HTMLElement {
    connectedCallback() {
      if (this.kcReady) return;
      this.kcReady = true;
      this.addEventListener('click', (e) => {
        const swatch = e.target.closest('[data-kc-swatch]');
        if (!swatch || !this.contains(swatch)) return;
        e.preventDefault();
        this.select(swatch);
      });
      const warm = (e) => {
        const swatch = e.target.closest && e.target.closest('[data-kc-swatch]');
        if (!swatch) return;
        const img = this.querySelector('[data-kc-media="' + swatch.dataset.variant + '"] img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      };
      this.addEventListener('pointerover', warm);
      this.addEventListener('focusin', warm);
    }

    select(swatch) {
      const id = swatch.dataset.variant;
      this.querySelectorAll('[data-kc-swatch]').forEach((b) => b.setAttribute('aria-pressed', b === swatch ? 'true' : 'false'));
      this.querySelectorAll('[data-kc-media]').forEach((m) => { m.hidden = m.dataset.kcMedia !== id; });
      if (swatch.dataset.url) this.querySelectorAll('[data-kc-link]').forEach((a) => { a.href = swatch.dataset.url; });
      const price = this.querySelector('[data-kc-price]');
      if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;
      const name = this.querySelector('[data-kc-color]');
      if (name && swatch.dataset.name) name.textContent = swatch.dataset.name;
    }
  }
  customElements.define('kc-set-card', KcSetCard);
}
